import {observer} from "mobx-react";
import React from "react";
import {
    IPsoFamilyAgreementViewModel
} from "../../../../../../services/booking/models/pso/agreements/families/pso-family-agreement.view-model.interface";
import {FieldsContainerBox, FullGridLineBox} from "../../../common/boxes/pso-agreement.boxes";
import {StringFieldEditorComponent} from "../../../../../forms/string-field/string-field-editor.component";
import {
    DateFieldEditorWithInputMaskComponent
} from "../../../../../forms/date-time/date-field-editor-with-input-mask.component";



export const LegalGuardianDetailsComponent: React.FC<{familyAgreement: IPsoFamilyAgreementViewModel}> = observer((props) => {

    if(props.familyAgreement.fields.guardianshipIssuedByCourt.isHidden) {
        return null;
    }

    return (
        <FullGridLineBox>
            <FieldsContainerBox>
                <FullGridLineBox>
                   <StringFieldEditorComponent field={props.familyAgreement.fields.guardianshipIssuedByCourt}/>
                </FullGridLineBox>
                <DateFieldEditorWithInputMaskComponent field={props.familyAgreement.fields.guardianshipIssueDate}/>
                <StringFieldEditorComponent field={props.familyAgreement.fields.guardianshipDocumentNumber}/>
            </FieldsContainerBox>
        </FullGridLineBox>

    )
})